import { Component, ViewChild } from '@angular/core';
import { UnitDetailsCalendarComponent } from '../unit-details-calendar/unit-details-calendar.component';

@Component({
  selector: 'app-unit-details',
  templateUrl: './unit-details.component.html',
  styleUrls: ['./unit-details.component.scss'],
})
export class UnitDetailsComponent {
  @ViewChild(UnitDetailsCalendarComponent) calendar_component?: UnitDetailsCalendarComponent;

  current_month: number = new Date().getMonth();
  current_year: number = new Date().getFullYear();

  onMonthChange(month: number): void {
    this.current_month = month;
    this.calendar_component?.setCells(this.current_year, this.current_month);
  }

  onYearChange(year: number): void {
    this.current_year = year;
    this.calendar_component?.setCells(this.current_year, this.current_month);
  }
}
